// ---------------------------------------------------------
// | Imports
// ---------------------------------------------------------

// Common of angular

import { NgModule, ModuleWithProviders } from '@angular/core';

// Services

import { API } from './services/api';

// Directives

import { DirectivesModule } from './share/directives/yzt-directives.modules';

// Tokens (eg. global services' config)

// Modules

import { NgZorroAntdModule } from 'ng-zorro-antd';
import { EchartsModule } from './echarts/echarts.component';
import { UIGridModule } from './yzt-grid/yzt-grid.component';
import { ShipperSelectModule } from './shipper-select/shipper-select.component';
import { GridIconModule } from './yzt-grid/grid-icon.component';
import { CustomTemplateModule } from './yzt-grid/custom-template.component';
import { YztUploadModule } from './upload/yzt-upload.module';
import { YZTViewerDirectiveModule } from './yzt-viewer/yzt-viewer.directive';
import { RepairGoodSelectModule } from './repair-goods-select/repair-goods-select.component';
import { CneeSelectModule } from './cnee-select/cnee-select.component';
import { MasterSelectModule } from './master-select/master-select.component';
import { AreaSelectModule } from './area-select/area-select.component';
import { AbnormalSelectModule } from './abnormal-select/abnormal-select.component';
import { DepartmentSelectModule } from './department-select/departement-select.component';
import { CitySelectModule } from './city-select/city-select.component';
import { YztTabsModule } from './yzt-tabs/yzt-tabs.module';
import { PickAddrModule } from './pick-addr/pick-addr.component';
import { CustomerGoodtModule } from './customer-good/customer-good.component';
import { StandardGoodModule } from './standard-good/standard-good.component';
import { AreaDownSelectModule } from './area-down-select/area-down-select.component';
import { CustomerAndCargoGoodtModule } from './customerAndCargo-good/customerAndCargo-good.component';
import { ApiService } from './services/api.service';
// ---------------------------------------------------------
// | Exports
// ---------------------------------------------------------
// interface
export {YztUploadFile} from './upload/interface';

// Modules
export { NgZorroAntdModule } from 'ng-zorro-antd';
export { EchartsModule } from './echarts/echarts.component';
export { UIGridModule } from './yzt-grid/yzt-grid.component';
export { ShipperSelectModule } from './shipper-select/shipper-select.component';
export { GridIconModule } from './yzt-grid/grid-icon.component';
export { CustomTemplateModule } from './yzt-grid/custom-template.component';
export { YztUploadModule } from './upload/yzt-upload.module';
export { YZTViewerDirectiveModule } from './yzt-viewer/yzt-viewer.directive';
export { RepairGoodSelectModule } from './repair-goods-select/repair-goods-select.component';
export { CneeSelectModule } from './cnee-select/cnee-select.component';
export { MasterSelectModule } from './master-select/master-select.component';
export { AreaSelectModule } from './area-select/area-select.component';
export { AbnormalSelectModule } from './abnormal-select/abnormal-select.component';
export { DepartmentSelectModule } from './department-select/departement-select.component';
export { CitySelectModule } from './city-select/city-select.component';
export { YztTabsModule } from './yzt-tabs/yzt-tabs.module';
export { PickAddrModule } from './pick-addr/pick-addr.component';
export { CustomerGoodtModule } from './customer-good/customer-good.component';
export { StandardGoodModule } from './standard-good/standard-good.component';
export { AreaDownSelectModule } from './area-down-select/area-down-select.component';
export { CustomerAndCargoGoodtModule } from './customerAndCargo-good/customerAndCargo-good.component';
export class ZorroExtModule {
/**
 * @param {?} CustomAPI
 * @param {?} API_BASE_URL
 * @return {?}
 */
static forRoot(CustomAPI, API_BASE_URL): ModuleWithProviders {
    return {
      ngModule: ZorroExtModule,
      providers: [
        ApiService,
        { provide: API, useClass: CustomAPI },
        { provide: 'API_BASE_URL', useValue: API_BASE_URL }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [
    // NgZorroAntdModule,
    EchartsModule,
    UIGridModule,
    ShipperSelectModule,
    RepairGoodSelectModule,
    GridIconModule,
    CustomTemplateModule,
    DirectivesModule,
    YztUploadModule,
    YZTViewerDirectiveModule,
    CneeSelectModule,
    MasterSelectModule,
    AbnormalSelectModule,
    AreaSelectModule,
    DepartmentSelectModule,
    CitySelectModule,
    YztTabsModule,
    PickAddrModule,
    CustomerGoodtModule,
    StandardGoodModule,
    AreaDownSelectModule,
    CustomerAndCargoGoodtModule
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ZorroExtModule_tsickle_Closure_declarations() {
/** @type {?} */
ZorroExtModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ZorroExtModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
